import { createAction } from 'redux-actions';
import { MESSAGE_SENT } from '../constants/actionTypes';
export const messageSent = createAction(MESSAGE_SENT);